// @generated by protoc-gen-connect-es v1.6.1 with parameter "target=ts"
// @generated from file announcement/v1/service.proto (package announcement.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ListAnnouncementsRequest, ListAnnouncementsResponse, ReadAnnouncementsRequest, ReadAnnouncementsResponse } from "./service_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * The following error codes are not stated explicitly in the each rpc, but may be returned.
 *   - shared.InvalidArgument
 *   - shared.Unauthenticated
 *   - shared.Unauthorized
 *
 * @generated from service announcement.v1.AnnouncementService
 */
export const AnnouncementService = {
  typeName: "announcement.v1.AnnouncementService",
  methods: {
    /**
     * @generated from rpc announcement.v1.AnnouncementService.ListAnnouncements
     */
    listAnnouncements: {
      name: "ListAnnouncements",
      I: ListAnnouncementsRequest,
      O: ListAnnouncementsResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc announcement.v1.AnnouncementService.ReadAnnouncements
     */
    readAnnouncements: {
      name: "ReadAnnouncements",
      I: ReadAnnouncementsRequest,
      O: ReadAnnouncementsResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

